<template>
  <div class="w-screen h-screen bg-gray-100 flex items-center justify-center">
    <div class="bg-white rounded-lg w-64 shadow-xl">
      <img
        src="https://s3-eu-central-1.amazonaws.com/neticle-images/2019/10/textapi_256-1.png"
        class="inline-block mx-auto mt-6 mb-4 w-10"
      >
      <div class="mx-6">
        <z-input
          v-model="firstName"
          label="First name"
          class="mb-4"
          :error-message="isFirstNameEmpty ? 'Required' : ''"
          @blur="validateFirstName"
        />
        <z-input
          v-model="lastName"
          label="Last name"
          class="mb-4"
          :error-message="isLastNameEmpty ? 'Required' : ''"
          @blur="validateLastName"
        />
        <z-input
          v-model="password"
          label="Password"
          type="password"
          class="mb-4"
          :error-message="isPasswordValid ? '' : 'The password must be at least 8 characters long'"
          @blur="validatePassword"
        />
        <z-input
          v-model="passwordConfirm"
          label="Password Confirmation"
          type="password"
          :error-message="isPasswordTheSame ? '' : 'Password confirmation doesn\'t match the original password'"
          class="mb-4"
          @blur="validateConfirm"
        />
      </div>
      <div
        class="bg-blue-400 rounded-b-lg py-4 text-white cursor-pointer"
        @click="submit"
      >
        Activate
      </div>
    </div>
  </div>
</template>

<script>
import ZInput from '@/global/ui/Input'
import { actionNames } from '@/store'

export default {
  name: 'Activate',
  components: { ZInput },
  data () {
    return {
      firstName: '',
      lastName: '',
      password: '',
      passwordConfirm: '',
      isFirstNameEmpty: false,
      isLastNameEmpty: false,
      isPasswordValid: true,
      isPasswordTheSame: true
    }
  },
  methods: {
    validatePassword () {
      this.isPasswordValid = this.password.length > 7
    },
    validateConfirm () {
      this.isPasswordTheSame = this.password === this.passwordConfirm
    },
    validateFirstName () {
      this.isFirstNameEmpty = this.firstName.length === 0
    },
    validateLastName () {
      this.isFirstNameEmpty = this.lastName.length === 0
    },
    async submit () {
      this.validateFirstName()
      this.validateLastName()
      this.validatePassword()
      this.validateConfirm()
      if (!this.isPasswordValid || !this.isPasswordTheSame || this.isFirstNameEmpty || this.isLastNameEmpty) return
      try {
        await this.$store.dispatch(actionNames.ACTIVATE, {
          firstName: this.firstName,
          lastName: this.lastName,
          password: this.password,
          token: this.$route.params.token
        })
        this.$toast.info('Successful activation, you will be redirected to your dashboard.')
        await this.$router.push('/')
      } catch (e) {
        this.$toast.error('Something went wrong, please try again later.')
      }
    }
  }
}
</script>
